module.exports = __webpack_public_path__ + "static/media/car-marker-onjob.9039a5a6.png";